import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-license">
          <strong>Free Access:</strong> This tool is provided free of charge for research and surveillance purposes.
          Data is sourced from <a href="https://gisaid.org/" target="_blank" rel="noopener noreferrer">GISAID</a> and distributed under <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">CC BY 4.0</a> License.
        </div>

        <div className="footer-resources">
          <Link to="/help">Help & Documentation</Link>
          <span className="separator">•</span>
          <Link to="/about">About</Link>
          <span className="separator">•</span>
          <a href="https://gisaid.org/terms-of-use/" target="_blank" rel="noopener noreferrer">GISAID Terms</a>
        </div>

        <div className="footer-copyright">
          &copy; {currentYear} WiseFlu. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
